import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import AiMessageDropdown from 'components/Ai/MessageDropdown'
import memoEmoji from 'assets/icons/emoji/memo.png'
// import magicWand from 'assets/icons/emoji/magic-wand.png'
import nerdFace from 'assets/icons/emoji/nerd-face.png'
import luggage from 'assets/icons/emoji/luggage.png'
import manDancing from 'assets/icons/emoji/man-dancing.png'
import writingHand from 'assets/icons/emoji/writing-hand.png'
import sparkles from 'assets/icons/emoji/sparkles.png'
// import manRisingHand from 'assets/icons/emoji/man-raising-hand.png'
import scroll from 'assets/icons/emoji/scroll.png'
import { selectIsAddingNote } from 'selectors/page'
import { doInitializeRequest } from 'ducks/ai/operations'
import {
  SPELLING_ACTION,
  SHORTEN_ACTION,
  LENGTHEN_ACTION,
  FORMAL_ACTION,
  CASUAL_ACTION,
  CLARIFY_ACTION,
  REQUEST_TYPES,
  CREATE_REPLY_ACTION,
} from 'ducks/ai/types'
import { isFeatureEnabled, record } from 'ducks/tracking/actions'

// add isTextSelected as the param in generateItems when we will have more working options
const generateItems = (isNote, editorName) => {
  const buttonActions = []
  const ticketActions = {
    name: 'GENERATE FROM CONVERSATION',
    items: [],
  }

  ticketActions.items.push({
    id: CREATE_REPLY_ACTION,
    name: 'Generate a reply draft to the customer',
    icon: sparkles,
  })
  if (isFeatureEnabled('ai-experimental-features', true)) {
    buttonActions.push(ticketActions)
  }

  let editorActions

  if (editorName) {
    const editorActionSelectionText = isNote ? 'note' : 'reply'

    editorActions = {
      name: `EDIT OR REVIEW YOUR ${editorActionSelectionText.toUpperCase()}`,
      items: [
        {
          id: SPELLING_ACTION,
          name: 'Fix spelling & grammar',
          icon: nerdFace,
        },
        {
          id: SHORTEN_ACTION,
          name: 'Make shorter',
          icon: memoEmoji,
        },
        {
          id: LENGTHEN_ACTION,
          name: 'Make longer',
          icon: scroll,
        },
        {
          id: FORMAL_ACTION,
          name: `Make ${editorActionSelectionText} more formal`,
          icon: luggage,
        },
        {
          id: CASUAL_ACTION,
          name: `Make ${editorActionSelectionText} more casual`,
          icon: manDancing,
        },
        {
          id: CLARIFY_ACTION,
          name: 'Simplify language',
          icon: writingHand,
        },
      ],
    }
    buttonActions.push(editorActions)
  }

  return buttonActions
}

const AiButton = React.memo(({ position = 'top-start', editorName }) => {
  const dispatch = useDispatch()
  const isNote = useSelector(selectIsAddingNote)

  const loadMenu = useCallback(
    () => {
      return generateItems(isNote, editorName)
    },
    [isNote, editorName]
  )

  const onAiOptionSelected = useCallback(
    async item => {
      if (!item?.id) return
      record()
      dispatch(doInitializeRequest(REQUEST_TYPES[item.id], item.id))
    },
    [dispatch]
  )

  return (
    <AiMessageDropdown
      onAiOptionSelected={onAiOptionSelected}
      list={loadMenu}
      position={position}
      // Only show the text modifications callout in the editor
      featureCalloutHidden={!editorName}
    />
  )
})

export default AiButton
